const AssessmentSvg = (props: any) => {
  if (props.outlined) {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.6667 2.66667H26.6667C27.0203 2.66667 27.3594 2.80714 27.6095 3.05719C27.8595 3.30724 28 3.64638 28 4V28C28 28.3536 27.8595 28.6928 27.6095 28.9428C27.3594 29.1929 27.0203 29.3333 26.6667 29.3333H5.33333C4.97971 29.3333 4.64057 29.1929 4.39052 28.9428C4.14048 28.6928 4 28.3536 4 28V4C4 3.64638 4.14048 3.30724 4.39052 3.05719C4.64057 2.80714 4.97971 2.66667 5.33333 2.66667H9.33333V0H12V2.66667H20V0H22.6667V2.66667ZM22.6667 5.33333V8H20V5.33333H12V8H9.33333V5.33333H6.66667V26.6667H25.3333V5.33333H22.6667ZM9.33333 10.6667H22.6667V13.3333H9.33333V10.6667ZM9.33333 16H22.6667V18.6667H9.33333V16Z"
          fill="white"
        />
      </svg>
    )
  }
  return (
    <svg
      width="24"
      height="30"
      viewBox="0 0 24 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.6667 2.66667H22.6667C23.0203 2.66667 23.3594 2.80714 23.6095 3.05719C23.8595 3.30724 24 3.64638 24 4V28C24 28.3536 23.8595 28.6928 23.6095 28.9428C23.3594 29.1929 23.0203 29.3333 22.6667 29.3333H1.33333C0.979711 29.3333 0.640573 29.1929 0.390524 28.9428C0.140476 28.6928 0 28.3536 0 28V4C0 3.64638 0.140476 3.30724 0.390524 3.05719C0.640573 2.80714 0.979711 2.66667 1.33333 2.66667H5.33333V0H8V2.66667H16V0H18.6667V2.66667ZM5.33333 10.6667V13.3333H18.6667V10.6667H5.33333ZM5.33333 16V18.6667H18.6667V16H5.33333Z"
        fill="#EA1E61"
      />
    </svg>
  )
}

export default AssessmentSvg
